<template>
  <div class="BBSAnswerEditDiv">
    <label class="BBSAnswerEditHeader">{{ i18n.$t('BBSAnswerEditHeader') }}</label>
    <tinymce-editor
        ref="editor"
        :tinymceHeight = 300
        class="BBSAnswerEditContent"
        v-model="BBSAnswerEditContent"
        :value="BBSAnswerEditContent"
        @input="handleInput"
        :disabled="disabled"
        @onClick="onClick"
    >
    </tinymce-editor>
    <div class="BBSAnswerEditButtonDiv">
        <img class="BBSAnswerEditButton" @click="EditBBSAnswer()" src="@/assets/svg/botton_发表.svg">
        <img class="BBSAnswerEditButton" @click="GoBack()" src="@/assets/svg/botton_取消.svg">
    </div>
  </div>
</template>

<script>
import { useI18n } from "@/i18nPlugin";
import { defineComponent, ref } from "vue";
import { useRouter } from 'vue-router';
import { 
    SearchBBSAnswerDetailData,
    EditBBSAnswerData,
} from '../api/index';
import TinymceEditor from "@/components/tinymce-editor/tinymce-editor";
export default defineComponent({
  components: {
    TinymceEditor,
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const token = localStorage.getItem("userToken");
    const BBSAnswerEditContent = ref("");

    const handleInput = (value) => {
      BBSAnswerEditContent.value = value;
    //   console.log(value);
    };
    // 鼠标单击的事件
    const onClick = (e, editor) => {
    //   console.log("Element clicked");
    //   console.log(e);
    //   console.log(editor);
    };
    const SearchBBSAnswerDetail = () => {
        SearchBBSAnswerDetailData ({
            id: EditId
        }).then(res => {
            BBSAnswerEditContent.value = res.data.content;
            // console.log(res)
        }).catch(error => {
            console.log(error)
        });
    }
    const EditBBSAnswer = () => {
        EditBBSAnswerData ({
            id: EditId,
            content: BBSAnswerEditContent._rawValue,
        },token).then(res => {
            if(res.status == 200){
                router.push({ path: '/ATS/PersonalCenter', query: { type: "Answer" }});
            }
        }).catch(error => {
            // this.$message.danger('添加失败');
            console.log(error);
        })
    }

    const  getQueryVariable = (variable) =>{
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }

    const EditId = getQueryVariable("id");

    const GoBack = () => {
        history.go(-1);
    }

    return { 
        i18n,
        token,
        BBSAnswerEditContent,
        EditId,
        handleInput,
        SearchBBSAnswerDetail,
        getQueryVariable,
        onClick,
        EditBBSAnswer,
        GoBack
    };
  },
  mounted() {
      if(this.EditId.value != false) {
          this.SearchBBSAnswerDetail();
      }
  }
});
</script>

<style lang="less" scoped>
.BBSAnswerEditDiv {
    padding: 30px 50px;
    text-align: left;
    .BBSAnswerEditHeader {
        font-size: 16px;
        font-weight: bold;
    }
    .BBSAnswerEditTitle {
        margin-top: 15px;
        border:  1px solid #D7D7D7;
    }
    .BBSAnswerEditContent {
        margin-top: 15px;
    }
    .BBSAnswerEditTypeTitle {
        font-weight: bold;
        font-size: 14px;
    }
    .BBSAnswerEditTypeDiv {
        margin-top: 20px;
    }
    .BBSAnswerEditType {
        margin-top: 20px;
    }
    .BBSAnswerEditButtonDiv {
        margin-top: 20px;
    }
    .BBSAnswerEditButton {
        cursor: pointer;
        width: 125px;
        height: 35px;
        margin-left: 20px;
        margin-bottom: 20px;
        float: right;
    }
}
</style>